import { render, staticRenderFns } from "./ConfigMapKey.vue?vue&type=template&id=70637563"
import script from "./ConfigMapKey.vue?vue&type=script&lang=js"
export * from "./ConfigMapKey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports